import React from 'react'
import {Box,Typography} from "@material-ui/core"
function Statistiques(props) {
    return (
        <div>
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" style={{height: "100vh"}}>

            <Typography variant="h1" color="textSecondary"> Not Implemented Yet</Typography>
            <Typography variant="h5" color="textSecondary"> Coming Soon</Typography>
            </Box>

            
        </div>
    )
}

export default Statistiques

